import {
	ChangeDetectionStrategy,
	Component,
} from '@angular/core';

import { CommonBaseComponent } from '@CaseOne/Common/base_component/base.component';

@Component({
	selector: 'common-popup-overlay-background',
	templateUrl: './popup-overlay-background.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonPopupOverlayBackgroundComponent extends CommonBaseComponent {}
